import Vue from 'vue';
// WeakMap是一种键值对的集合
// 这里用来将一个dom元素和一种动画对应起来
const map = new WeakMap()
 
// 创建一个观察对象
const ob = new IntersectionObserver(entries => {
  // 遍历所有被观察的元素 entries为一个数组
  for (const entry of entries) {
    // 判断该元素是否与视口相交（出现在视口里面了）
    if (entry.isIntersecting) {
      // 判断目标元素是出现在上视口还是下视口
      if (entry.boundingClientRect.top > entry.rootBounds.top) {
        // 找出这个元素对应的动画
        const animation = map.get(entry.target)
        if (animation) {
          // 播放该元素的动画
          animation.play()
        }
      }
    }
  }
})
// 辅助函数,用来判断页面上的元素是否在视口外
function isBelowViewport(el) {
  const rect = el.getBoundingClientRect()
  return rect.top > window.innerHeight
}
 
Vue.directive('slide-in', {
  inserted(el) {
    // 如果元素已经在视口内了，直接return 不加动画
    if (!isBelowViewport(el)) return
    //  创建一个动画  animate是Vue自带的
    const animation = el.animate(
      [
        // 数组的每一个对象都表示关键帧 相当于css中的 @keyframes 这里想写多少个就写多少个
        {
          transform: `translateY(${100}px)`,
        },
        {
          transform: `translateY(0px)`,
        },
      ],
      // duration：执行时间  easing：动画效果，fill:动画结束过后的行为  这些跟css中的一样
      { duration: 500, easing: 'ease-in-out', fill: 'forwards' }
    )
    // 一开始的时候让动画暂停，这里只是先定义好
    animation.pause()
    // 当元素进入视口的时候在进行动画播放
    ob.observe(el)
    // 存储键值
    map.set(el, animation)
  },
  // 在元素卸载时，取消观察
  unbind(el) {
    ob.unobserve(el)
  },
})

Vue.directive('autoplay-video', {
  inserted: function (el) {
    let video = el
    if (video.tagName.toLowerCase() === 'video') {
      let observer = new IntersectionObserver((entries) => {
        let hasPlayed = false;
        entries.forEach((entry) => {
          console.log(entry, hasPlayed, video);
          
          if (entry.isIntersecting && !hasPlayed) {
            hasPlayed = true;
            video.play()
            observer.disconnect()
          }
        });
      });
      observer.observe(video)
    }
  }
})
